// src/Layout.js
import React, { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Navbar from './components/Navbar';

function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>
      {/* Sidebar Section */}
      <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />

      <div
        style={{
          padding: '0px',
          marginLeft: isMobile ? '0px' : '250px',
          // transition: "margin-left 0.3s ease-in-out",
        }}
      >
        <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
        <Outlet />
      </div>
    </>
  );
}

export default Layout;

// import React, { useState, useEffect } from "react";
// import { Outlet } from "react-router-dom";
// import Sidebar from "./components/Sidebar";
// import Navbar from "./components/Navbar";

// function Layout() {
//   const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false); // ✅ Lift state up

//   useEffect(() => {
//     const handleResize = () => {
//       setIsMobile(window.innerWidth <= 768);
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   return (
//     <div>
//       {/* Pass sidebar state to Navbar and Sidebar */}
//       <Sidebar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
//       <div
//         style={{
//           padding: "0px",
//           marginLeft: isMobile ? "0px" : "250px",
//         }}
//       >
//         <Navbar isSidebarOpen={isSidebarOpen} setIsSidebarOpen={setIsSidebarOpen} />
//         <Outlet />
//       </div>
//     </div>
//   );
// }

// export default Layout;
